import React, { useContext, useEffect } from "react";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

import { Stage, Layer, Line } from "react-konva";

import Header from "../components/Header";
import ChapitreListItem from "../components/ChapitreListItem";
import LockButton from "../components/LockButton";

function Accueil() {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  useEffect(() => {
    appDispatch({
      type: "CLEAR_ALL_CANVAS",
      value: false,
    });
  }, []);

  useEffect(() => {
    if (appState.scrollTo) {
      if (parseInt(appState.scrollTo) > appState.chapitres.length) {
        document
          .getElementById(`footer`)
          .scrollIntoView({ behavior: "smooth", block: "end" });
      } else {
        document
          .getElementById(`chapitre-${appState.scrollTo}`)
          .scrollIntoView({ behavior: "smooth", block: "center" });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [appState.scrollTo]);

  useEffect(() => {
    let allChaptersUnlocked = true;
    for (let chapterIdx in appState.status) {
      if (appState.status[chapterIdx].locked == true) {
        allChaptersUnlocked = false;
      }
    }
    appDispatch({
      type: "UPDATE_GLOBAL_LOCK_STATUS",
      value: allChaptersUnlocked,
    });
  }, [appState.lockCounter]);

  function handleFinishAudioClick() {
    appDispatch({
      type: "OPEN_MEDIA_PLAYER",
      mediaType: "audio",
      mediaSrc: appState.livre.stopAudio,
    });
  }

  return (
    <>
      <Header
        pageName="accueil"
        titre={appState.livre.titre}
        sousTitre={appState.livre.sousTitre}
        showStart={true}
        showReinit={true}
        showMascotte={false}
      />
      <Stage
        id="path-canvas"
        className="section-chapitre__path"
        width={appState.canvasClear === true ? 1 : window.innerWidth}
        height={appState.canvasClear === true ? 1 : document.body.offsetHeight}
      >
        <Layer>
          {appState.paths.map((patharray, index) =>
            patharray.map((path, index) => (
              <Line
                key={`line-${index}`}
                x={0}
                y={0}
                points={[
                  path.startX,
                  path.startY,
                  path.step1X,
                  path.step1Y,
                  path.step2X,
                  path.step2Y,
                  path.stopX,
                  path.stopY,
                ]}
                bezier="true"
                dash={[0.001, 24]}
                stroke={path.color}
                strokeWidth={8}
                lineJoin="round"
                lineCap="round"
              />
            ))
          )}
        </Layer>
      </Stage>

      <section className="chapters">
        {appState.chapitres.map((chapitre, index, { length }) => {
          return (
            <ChapitreListItem
              {...chapitre}
              key={index}
              index={index}
              chapitresLength={length}
              isbn={appState.livre.isbn}
            />
          );
        })}
      </section>
      <footer id="footer" className="page-footer accueil-footer">
        <div
          className={`page-footer__arrivee ${
            appState.allChaptersUnlocked ? "unlocked" : "locked"
          }`}
        >
          <h2>Arrivée</h2>
          <button
            className={`btn btn-play btn-arrivee ${
              appState.allChaptersUnlocked ? "" : "disabled"
            }`}
            onClick={handleFinishAudioClick}
          >
            <span className="visually-hidden">Jouer l’animation d’arrivée</span>
          </button>
        </div>
        <div className="page-footer__coffre">
          <div
            className={`page-footer__coffre--img page-footer__coffre--${
              appState.allChaptersUnlocked ? "open" : "closed"
            }`}
          >
            <span className="visually-hidden">
              {appState.allChaptersUnlocked ? "Coffre ouvert" : "Coffre fermé"}
            </span>
          </div>
          <div className="page-footer__coffre--keys">
            {appState.chapitres.map((chapitre, index, { length }) => {
              return <LockButton parentIdx={index} readOnly={true} />;
            })}
          </div>
        </div>
        {appState.allChaptersUnlocked ? (
          <a
            className="btn btn-standard btn-certificat"
            href={appState.livre.certificat}
            rel="noreferrer"
            target="_blank"
          >
            {appState.livre.certificatDownloadText}
          </a>
        ) : null}
      </footer>
    </>
  );
}

export default Accueil;
